import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "instagram",
  "use": "instagram-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"instagram\"><rect x=\"1\" y=\"1\" width=\"20\" height=\"20\" rx=\"5\" ry=\"5\" /><path d=\"M15,10.37A4,4,0,1,1,11.63,7,4,4,0,0,1,15,10.37Z\" /><line x1=\"16.5\" y1=\"5.5\" x2=\"16.5\" y2=\"5.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/instagram.svg
// module id = 1173
// module chunks = 0